import { Routes } from '@angular/router';
import { DashboardPage } from './pages/dashboard-page/dashboard-page';
import { locationsLoadedGuard } from '../locations/guards/locations-loaded.guard';
import { energyInterfacesLoadedGuard } from '../energy-interfaces/guards/energy-interfaces-loaded.guard';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    canActivate: [locationsLoadedGuard, energyInterfacesLoadedGuard],
    component: DashboardPage,
  },
];
